import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { Button } from "../ui/button";
import { RESPONSIVE_ICON_BUTTON_CLASS } from "~/lib/touchTarget";
import type { TimelineMinimapItem } from "./timelineMinimapItems";

export function TurnStep(props: {
  readonly direction: "previous" | "next";
  readonly items: readonly TimelineMinimapItem[];
  readonly currentIndex: number;
  readonly onSelect: (item: TimelineMinimapItem) => void;
}) {
  const previous = props.direction === "previous";
  const item = props.items[props.currentIndex + (previous ? -1 : 1)];
  const Icon = previous ? ChevronUpIcon : ChevronDownIcon;
  return (
    <Button
      type="button"
      variant="ghost"
      className={RESPONSIVE_ICON_BUTTON_CLASS}
      aria-label={previous ? "Previous turn" : "Next turn"}
      disabled={!item}
      onClick={() => {
        if (item) props.onSelect(item);
      }}
    >
      <Icon className="size-4" />
    </Button>
  );
}
